import React, {useCallback, useEffect} from 'react'
import {connect} from 'react-redux'
import Utils from "@/utils/Default/Utils";
import * as actions from "@/redux/reducers/Default/productList/productListActions";
import {
    showProductHandleClick,
    scrollToDiv
} from "@/animations/Default/productListPage"
import {synchronizeShopCircle, getPrimaryShopData} from '@/redux/reducers/Default/header/headerActions'
import productListAnimation from "@/animations/Default/productListPage";
import OctipasMerch from "@/utils/Default/OctipasMerch"
import List from "./List";
import {SEARCH_PAGE} from "@/utils/constants";
import {
    handleNavigation,
    fetchItemsFromNavigation
} from "@/redux/reducers/Default/productList/productListActions";
import {HANDLE_IS_PAGINATION_LOADING, HANDLEAPISTATUSPENDING} from "@/redux/reducers/Default/actionsTypes";
import {useLifeCycleEffect} from "@/customHooks/hooks";

const ProductListContainer = (props) => {
    const {
        shopCircleVersion,
        productsListData,
        desactivateT2s,
        fetchProductsAvailabilities,
        getPrimaryShopData,
        shop,
        madIsActifInFiltredProductList,
        filters,
        appliedFiltersValues,
        merchListItems,
        handleApiStatusPending,
        handleIsPaginationLoading,
        handleNavigation,
        previousPager,
        pager,availabilityDisplayMode,
        productsAvailabilityData,
        adsenseStatus,
        currentFiltersValue,
        category,
        showPreviousPage,
        apiStatusPending,
        isPaginationLoading,
        isSeeMoreLoader,
        adaptiveLoadingResources,
        octipasPayload,
        htOptin,
        ABTastyCookieIsActive
    } = props;

    useLifeCycleEffect(() => {
        synchronizeShopCircle(shopCircleVersion).then(() => {
            handlePostSynchronizedShopCircleActions()
        });
    }, () => {
        showProductHandleClick();
        scrollToSelectedProduct();
        showTarget2Sell()
        OctipasMerch.setPayload(octipasPayload);
    })
    useEffect(()=>{
        if(Utils.getCookieValue('TC_PRIVACY') == null) {
            document.addEventListener("DOMNodeInserted", function (e) {
                if (e.target.id == "tc-privacy-wrapper" && typeof __tcfapi !== 'undefined') {
                    __tcfapi('addEventListener', 2, function (tcData, success) {
                        if (success && tcData.eventStatus === 'useractioncomplete') {
                            if(Utils.checkCookies(3) && (Utils.getCookieValue('passivegeoloc') == 'true' || !ABTastyCookieIsActive)) {
                                synchronizeShopCircle(shopCircleVersion).then(() =>  {
                                    handlePostSynchronizedShopCircleActions()
                                });
                            }
                        }
                    }.bind(this));
                }
            }.bind(this))
        }
    },[])
    const showTarget2Sell = () => {
        let isAvailabilityFilterActive = productsListData.appliedFiltersValues.some(item => item.filterCode == "AvailabilityShopIdList");
        if (htOptin || (productsListData?.currentSort?.label !== "Top ventes" && desactivateT2s === 1) || isAvailabilityFilterActive) {
            productListAnimation.drainTarget2SellContent();
        } else {
            productListAnimation.showTarget2SellContent()
            appData.actionTrigger.dispatch({
                trigger: "addTarget2Sell",
                payload: {}
            });
        }
    }
    const scrollToSelectedProduct = () => {
        let currentUrl = window.location.href;
        let selectedProductId = Utils.getParameterByName("selectedProductId", currentUrl);
        if (selectedProductId) {
            scrollToDiv(selectedProductId);
        }
    }

    const handlePostSynchronizedShopCircleActions = () => {
        let shopId = shop?.shopInfos?.id ? shop.shopInfos.id : ''
        let primaryShop = Utils.getPrimaryShopId();
        if (primaryShop && shopId != primaryShop) {
            getPrimaryShopData()
        }
        showTarget2Sell()
        if (productsListData && productsListData.listItems && productsListData.listItems.values && productsListData.listItems.values.length > 0 && Utils.getFetchingProductsAvailabilitiesIsAllowed(filters, madIsActifInFiltredProductList)) {
            fetchProductsAvailabilities(productsListData.listItems)
        }
    }

    const getProducts = useCallback((event, context) => {
        const {currentSort, listItems, id} = productsListData;
        const listItemsCount = listItems.values ? listItems.values.length : 0
        let currentFiltersValue = {};
        if (appliedFiltersValues) {
            appliedFiltersValues.map(function (filter, i) {
                if (!currentFiltersValue[filter.filterCode]) {
                    currentFiltersValue[filter.filterCode] = [];
                }
                currentFiltersValue[filter.filterCode].push(filter.value);
            });
        }
        event.preventDefault();
        event.stopPropagation();
        appData.actionTrigger.dispatch({
            trigger: context === 'seeMore' ? "seeMoreClicked" : 'seePreviousClicked'
        });
        handleApiStatusPending(true);
        handleIsPaginationLoading(true, context === 'seeMore');
        let page = context === 'seeMore' ? parseInt(pager.currentPageIndex) + 1 + 1 : parseInt(previousPager.currentPageIndex);
        if (page > 0 && page <= pager.pageCount) {
            let currentSortData = [null, currentSort.label, null, currentSort.value]
            handleNavigation(currentSortData, currentFiltersValue, context, pager, previousPager, page, listItems, merchListItems, listItemsCount, productsAvailabilityData, id);
        }
    }, [productsListData.currentSort, productsListData.listItems, productsListData.id, pager, previousPager, appliedFiltersValues, merchListItems, productsAvailabilityData])

    let listType = Utils.getMetaInfosValueByCode("TypeDescente", productsListData.category.metaInfos) === "Galerie générique" ? 'grid' : 'list';
    return (
        <List productsListData={productsListData} filters={filters} listType={listType}
              isSeeMoreLoader={isSeeMoreLoader} isPaginationLoading={isPaginationLoading}
              showPreviousPage={showPreviousPage} getProducts={getProducts} availabilityDisplayMode={availabilityDisplayMode}
              adsenseStatus={adsenseStatus} currentFiltersValue={currentFiltersValue} pager={pager}
              category={category} previousPager={previousPager}
              productsAvailabilityData={productsAvailabilityData}
                  apiStatusPending={apiStatusPending} adaptiveLoadingResources={adaptiveLoadingResources}
                  htOptin={htOptin}/>
    );
}


const mapStateToProps = (state, ownProps) => {
    return {
        productsListData: state.productList.changeFromClient ? state.productList.productsListData : ownProps.productsListData,
        pager: state.productList.changeFromClient ? state.productList.pager : ownProps.productsListData.pager,
        previousPager: state.productList.previousPager ? state.productList.previousPager : state.productList.changeFromClient ? state.productList.productsListData.pager : ownProps.productsListData.pager,
        availabilityDisplayMode: ownProps.availabilityDisplayMode,
        adsenseStatus: ownProps.adsenseStatus,
        desactivateT2s: ownProps.desactivateT2s,
        merchListItems: ownProps.context !== SEARCH_PAGE ? (state.productList.changeFromClient ? state.productList.productsListData.merchListItems : ownProps.merchListItems) : null,
        category: state.productList.changeFromClient ? state.productList.productsListData.category : ownProps.productsListData.category,
        appliedFiltersValues: state.productList.changeFromClient ? state.productList.productsListData.appliedFiltersValues : ownProps.appliedFiltersValues,
        madIsActifInFiltredProductList: state.productList.changeFromClient ? state.productList.madIsActifInFiltredProductList : ownProps.madIsActifInFiltredProductList,
        productsAvailabilityData: state.productList.productsAvailabilityData,
        filters: state.productList.changeFromClient ? state.productList.productsListData.filters.values : ownProps.filters.values,
        shop: state.header.shop,
        shopCircleVersion: ownProps.shopCircleVersion,
        showPreviousPage: ownProps.showPreviousPage,
        currentFiltersValue: state.productList.currentFiltersValue,
        octipasPayload: state.productList.changeFromClient ? state.productList.productsListData.octipasPayload : ownProps.productsListData.octipasPayload,
        apiStatusPending: state.productList.apiStatusPending,
        isPaginationLoading: state.productList.isPaginationLoading,
        isSeeMoreLoader: state.productList.isSeeMoreLoader,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchProductsAvailabilities: (productListItems) => dispatch(actions.fetchProductsAvailabilityData(productListItems)),
        handleApiStatusPending: (apiStatusPending) => dispatch({type: HANDLEAPISTATUSPENDING, payload: {apiStatusPending: apiStatusPending}}),
        handleIsPaginationLoading: (isPaginationLoading,isSeeMoreLoader) => dispatch({
            type: HANDLE_IS_PAGINATION_LOADING,
            payload: {isPaginationLoading: isPaginationLoading,isSeeMoreLoader :isSeeMoreLoader}
        }),
        fetchItemsFromNavigation: (categoryId, pager, currentIndex, currentSort, appliedFiltersValues, currentFiltersValue, keyWords) => dispatch(fetchItemsFromNavigation(categoryId, pager, currentIndex, currentSort, appliedFiltersValues, currentFiltersValue, keyWords)),
        handleNavigation: (currentSort, currentFiltersValue, context, pager, previousPager, page, listItems, merchListItems, listItemsCount, productsAvailabilityData, categoryId) => dispatch(handleNavigation(currentSort, currentFiltersValue, context, pager, previousPager, page, listItems, merchListItems, listItemsCount, productsAvailabilityData, categoryId)),
        getPrimaryShopData: () => dispatch(getPrimaryShopData())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductListContainer);
